export const ADMIN_RESET_FAV_PAGE = 'ADMIN_RESET_FAV_PAGE';
export const ADMIN_FETCH_FAV_PAGE = 'ADMIN_FETCH_FAV_PAGE';
export const ADMIN_CREATE_FAV_LINE = 'ADMIN_CREATE_FAV_LINE';
export const ADMIN_EDIT_FAV_LINE = 'ADMIN_EDIT_FAV_LINE';
export const ADMIN_DELETE_FAV_LINE = 'ADMIN_DELETE_FAV_LINE';
export const ADMIN_CREATE_FAV_LINE_CELL = 'ADMIN_CREATE_FAV_LINE_CELL';
export const ADMIN_EDIT_FAV_LINE_CELL = 'ADMIN_EDIT_FAV_LINE_CELL';
